import { CityState, DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutLocationContactQuickInfo extends Layout {
    citystateLocation: CityState;
    labelId: Label;
    panelLocationContactQuickInfo: Panel;
    sourceLocation: DataSource;
    textboxContactname: Textbox;
    textboxContactphone: Textbox;
    textboxName: Textbox;
    textboxReferenceNumbers: Textbox;
}
